import React from 'react';
export function AboutMission() {
  return <section className="py-20 bg-off-white" data-id="element-472">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-473">
        <p className="text-xl md:text-2xl text-ink leading-relaxed" data-id="element-474">
          At Storm Taekwondo, we believe in cultivating savage mental toughness
          and a "go getter" attitude in every student. Through our exciting and
          enriching sessions, we empower kids to become confident and resilient
          individuals, equipped with essential life skills.
        </p>
      </div>
    </section>;
}